module.exports = __webpack_public_path__ + "static/img/img_banner_b.60491a5b.png";